import { render, staticRenderFns } from "./WarrantyService.vue?vue&type=template&id=61cb70af&scoped=true"
import script from "./WarrantyService.vue?vue&type=script&lang=js"
export * from "./WarrantyService.vue?vue&type=script&lang=js"
import style0 from "./WarrantyService.vue?vue&type=style&index=0&id=61cb70af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61cb70af",
  null
  
)

export default component.exports